// extracted by mini-css-extract-plugin
export var dropdownButton = "_3o-0";
export var fullWidthDropdownButton = "_3o-1";
export var icon = "_3o-3";
export var iconPlaceholder = "_3o-2";
export var menuItemRow = "_3o-9";
export var separator = "_3o-e";
export var shortcutContainer = "_3o-7";
export var shortcutContainerFilled = "_3o-8";
export var shortcutIconLg = "_3o-6";
export var shortcutIconMd = "_3o-5";
export var shortcutIconSm = "_3o-4";
export var submenuChevron = "_3o-d";
export var submenuDropdown = "_3o-a";
export var submenuTriggerRow = "_3o-b";
export var submenuTriggerRowOpen = "_3o-c";